import { SearchModeEnum, StringSearchTypeEnum } from 'constants-activate';
import { IntegrationCategoryEnum } from 'constants-integrations';

export function getQueryVariables(primaryId: string) {
  const allIntegrationsVar = {
    search: {
      integrations: {
        deleted: false,
        integration: {
          category: {
            type: StringSearchTypeEnum.Equal,
            value: IntegrationCategoryEnum.AccessControl,
          },
        },
      },
    },
  };

  const focusChannelIntegrationsVar = {
    channelId: primaryId,
    search: {
      _id: primaryId,
      integrations: {
        deleted: false,
        integration: {
          category: {
            type: StringSearchTypeEnum.Equal,
            value: IntegrationCategoryEnum.AccessControl,
          },
        },
      },
    },
    relationshipSearch: {
      relatedTo: {
        _id: primaryId,
      },
      channel: {
        integrations: {
          deleted: false,
          integration: {
            category: {
              type: StringSearchTypeEnum.Equal,
              value: IntegrationCategoryEnum.AccessControl,
            },
          },
        },
      },
      searchMode: SearchModeEnum.And,
    },
    skipPagination: true,
  };

  return { allIntegrationsVar, focusChannelIntegrationsVar };
}
